import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiMail, FiLock, FiEye, FiEyeOff, FiArrowRight, FiMessageCircle } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';

export default function Login() {
    const [correo, setCorreo] = useState('');
    const [contrasena, setContrasena] = useState('');
    const [verPass, setVerPass] = useState(false);
    const [error, setError] = useState('');
    const [cargando, setCargando] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const enviar = async (e) => {
        e.preventDefault();
        setError('');
        if (!correo || !contrasena) { setError('Completa todos los campos'); return; }
        setCargando(true);
        try {
            const res = await login(correo, contrasena);
            if (res.usuario.rol === 'administrador') navigate('/admin');
            else navigate('/dashboard');
        } catch (err) {
            if (!err.response) {
                setError('No se puede conectar al servidor. Verifica que el backend este corriendo (npm start en /backend) y que XAMPP MySQL este activo.');
                return;
            }
            const data = err.response?.data;
            if (data?.requiereVerificacion) {
                navigate('/verificar-correo', { state: { correo: data.correo } });
                return;
            }
            setError(data?.error || `Error ${err.response.status}: no se pudo iniciar sesion`);
        } finally {
            setCargando(false);
        }
    };

    return (
        <div className="auth-wrapper">
            <div className="auth-card">
                <div className="auth-logo"><FiMessageCircle /></div>
                <h1 className="auth-title">Chucho Cursos</h1>
                <p className="auth-subtitle">Aprende a tu ritmo, certificate al final</p>

                {error && <div className="error-msg">{error}</div>}

                <form onSubmit={enviar}>
                    <div className="form-group">
                        <div className="input-icono">
                            <FiMail className="icono" size={16} />
                            <input
                                className="input"
                                type="text"
                                placeholder="Correo electronico"
                                value={correo}
                                onChange={e => setCorreo(e.target.value)}
                                autoComplete="username"
                                autoFocus
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <div className="input-icono">
                            <FiLock className="icono" size={16} />
                            <input
                                className="input con-icono-derecha"
                                type={verPass ? 'text' : 'password'}
                                placeholder="Contrasena"
                                value={contrasena}
                                onChange={e => setContrasena(e.target.value)}
                                autoComplete="current-password"
                            />
                            <button type="button" className="icono-derecha" onClick={() => setVerPass(v => !v)}>
                                {verPass ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                            </button>
                        </div>
                    </div>

                    <button type="submit" className="btn btn-primario btn-bloque" disabled={cargando}>
                        {cargando ? 'Entrando...' : <>Iniciar Sesion <FiArrowRight /></>}
                    </button>

                    <div className="auth-link">
                        <Link to="/recuperar-contrasena">¿Olvidaste tu contrasena?</Link>
                    </div>

                    <div className="auth-divider">o</div>

                    <Link to="/registro" className="btn btn-fantasma btn-bloque" style={{ textDecoration: 'none' }}>
                        Crear cuenta nueva
                    </Link>
                </form>
            </div>
        </div>
    );
}
